import React, { useState } from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import helpIcon from "../../../../../assets/disabilityIcons/IC_Help.svg";
import CollapseableTable from "../../../disaster/components/collapseAbleTable/CollapseableTable";
import useModuleData from "../../../disaster/hooks/useFetchItems";
import useCreateAttribute from "../../../disaster/hooks/useCreateAttribute";
import useModalHandlers from "../../../disaster/hooks/useModalHandler";
import useChangeHandler from "../../../disaster/hooks/useChangeHandler";
import useGetAttributes from "../../../disaster/hooks/useGetAttributes";
import { DisabilityFormCreator } from "../../../../../newComponents/V2Insurance/components/DisabilityFormCreator";
import UseUpdate from "../../../disaster/hooks/UseUpdate";
import { getAllColumns } from "./AllColumnsData";
import { Table } from "antd";
import useFetchContacts from "../../../disaster/hooks/useFetchContacts";
import useDeleteItem from "../../../disaster/hooks/useDeleteItem";
import CustomModal from "../../../../../components/styled-components/modal/custom-modal/custom-modal";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { ToolTipCreator } from "../../../../../helpers/ToolTipCreator";



const moduleNames = [
  "Insurance Policies Divorce",
 
];

export default function InsuranceCoverage() {
  const [loading, setLoading] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [moduleName, setModuleName] = useState(
    "Insurance Coverage"
  );
  const [formData, setFormData] = useState(null);
  const [attributesData, setAttributesData] = useState(null);
  const history = useHistory();

  const { attributes, disasterAttribute } = useGetAttributes(
    moduleNames,
    setLoading
  );

  const { showModal, updateModal, viewModal, handelCloseModal } =
  useModalHandlers(
    attributes,
    setModalTitle,
    setModuleName,
    setIsModalVisible,
    setFormData,
    setAttributesData
  );
const { handleChange, handleItemsInfoSelect } = useChangeHandler(setFormData);

  const {
    fetchData,
    disasterAttributeData,
    formatModuleKey,
    setTableData,
    setToUpdate,
    toUpdate,
    tableData,
  } = useModuleData(moduleNames, setLoading);

  const tableDataObj = {
    "Insurance Policies": tableData.insurancePoliciesDivorceData,
  };

  const { contactList } = useFetchContacts(setLoading);


  const { updateRecord } = UseUpdate(
    formData,
    setFormData,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  const { deleteRecord } = useDeleteItem(
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );
  

  const AllColumnsData = getAllColumns(viewModal, updateModal, deleteRecord);



  const { createAttributes } = useCreateAttribute(
    moduleName,
    formData,
    setFormData,
    setToUpdate,
    fetchData,
    formatModuleKey,
    setTableData,
    setLoading
  );

 
  const collapseableTable = [{ title: "Insurance Policies", key: 1 }];

 

  const AddContact = () => {
    history.push("/client/plan");
  };
  const AddDocument = () => {
    history.push("/organizer/important-document");
  };


  return(
    <div style={{ position: "relative" }}>
    <div className="parent-title-container">
      <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          <h2 className="parent-title">Insurance Coverage</h2>
          <ToolTipCreator name={"Divorce_Insurance_Coverage"}/>
      </div>
      {/* <div className="parent-icon-container">
        <img
          src={helpIcon}
          alt="help icon"
          width="18.67px"
          height="18.67px"
        />
      </div> */}
    </div>
    {collapseableTable.map((table, idx) => (
                <CollapseableTable
                  title={table.title}
                  key={table.key}
                  setFormData={setFormData}
                  formData={formData}
                  setModuleName={setModuleName}
                  //   handleFormDataUpdate={handleFormDataUpdate}
                  createAttributes={createAttributes}
                  onClick={() => showModal("Insurance Policies Divorce")
                  }
                  //   options={contactList}
                >
                  <Table
                            columns={AllColumnsData[table.title]}
                            dataSource={tableDataObj[table.title]}
                          />
                </CollapseableTable>
              ))}
              <div>
                  <CustomModal
          show={isModalVisible}
          fields={attributesData && attributesData}
          modalTitle={modalTitle}
          close={handelCloseModal}
          onChange={handleChange}
          onSelectChange={handleItemsInfoSelect}
          submitData={modalTitle !== "Update" ? createAttributes : updateRecord}
          selectedRowData={formData && formData}
          handleItemsInfoImageChange={formData}
          loading={loading}
        />
      </div>
      <NewLoader isLoading={loading} />
    </div>

  );

}